import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

/**
 * Tap-friendly time slot picker (better than native select on phones).
 */
export default function MobileTimeSlots({ slots, value, onChange, loading }) {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 2 }}>
        <CircularProgress size={22} />
        <Typography variant="body2" color="text.secondary">
          Loading times…
        </Typography>
      </Box>
    );
  }

  if (!slots?.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
        No slots for this date. Try another day.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: 1,
      }}
    >
      {slots.map((s) => {
        const selected = value === s.time;
        return (
          <Button
            key={s.time}
            type="button"
            variant={selected ? 'contained' : 'outlined'}
            onClick={() => onChange(s.time)}
            sx={{
              minHeight: 48,
              fontWeight: 700,
              borderRadius: 2,
              borderWidth: selected ? 0 : 2,
            }}
          >
            {s.label || s.time}
          </Button>
        );
      })}
    </Box>
  );
}
